import { Phone, MessageCircle, MapPin, Mail, Clock } from "lucide-react";
import { COMPANY } from "../../lib/constants";

export const ContactSection = () => {
  const waLink = `https://wa.me/${COMPANY.whatsapp.replace(/\D/g, "")}`;

  const items = [
    {
      icon: Phone,
      title: "Call us",
      lines: [COMPANY.phone, "Mon–Sun · 7am – 9pm"],
      href: `tel:${COMPANY.phoneClean}`,
      tone: "blue",
      testid: "contact-call",
    },
    {
      icon: MessageCircle,
      title: "WhatsApp",
      lines: ["Quick replies, anytime", "Tap to start a chat"],
      href: waLink,
      external: true,
      tone: "green",
      testid: "contact-whatsapp",
    },
    {
      icon: MapPin,
      title: "Service Area",
      lines: [COMPANY.area, "On-site visits available"],
      tone: "blue",
      testid: "contact-area",
    },
    {
      icon: Mail,
      title: "Email",
      lines: [COMPANY.email, "Quotes & inquiries"],
      href: `mailto:${COMPANY.email}`,
      tone: "blue",
      testid: "contact-email",
    },
  ];

  return (
    <section
      data-testid="contact-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-700">
            Get in Touch
          </div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light text-slate-900">
            We're <span className="font-medium">a call away.</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Prefer to talk? Reach our team directly via phone or WhatsApp for the fastest response.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            const tone =
              it.tone === "green"
                ? "bg-gradient-to-br from-[#25D366] to-[#1EBE5D] text-white"
                : "bg-gradient-to-br from-blue-600 to-sky-500 text-white";
            const Wrapper = it.href ? "a" : "div";
            const props = it.href
              ? {
                  href: it.href,
                  target: it.external ? "_blank" : undefined,
                  rel: it.external ? "noopener noreferrer" : undefined,
                }
              : {};
            return (
              <Wrapper
                key={i}
                {...props}
                data-testid={it.testid}
                className="group block bg-white border border-slate-100 rounded-2xl p-6 shadow-3d hover:shadow-3d-hover gradient-border tilt-card transition-all duration-500"
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center shadow-glow-soft group-hover:shadow-glow-blue transition-all duration-500 ${tone}`}>
                  <Icon className="w-5 h-5" strokeWidth={1.8} />
                </div>
                <h3 className="mt-5 font-display text-lg font-medium text-slate-900">
                  {it.title}
                </h3>
                <div className="mt-2 text-sm text-slate-600 space-y-1">
                  {it.lines.map((l, idx) => (
                    <div key={idx}>{l}</div>
                  ))}
                </div>
              </Wrapper>
            );
          })}
        </div>

        <div className="mt-10 inline-flex items-center gap-2 text-xs text-slate-500">
          <Clock className="w-3.5 h-3.5" /> Same-day responses · Limited weekly availability
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
